import { MenuItem } from "@mui/material";
import { NotificationTriggerFragmentFragment, UserPermissions } from "generated/graphql";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";
import UpdateEmailTriggerMenuItem from "../UpdateEmailTriggerMenuItem/UpdateEmailTriggerMenuItem";
import { useNavigate } from "react-router-dom";

export default function EmailTriggerMenuItems({
  id,
  closeMenu,
  isApi,
}: {
  id: NotificationTriggerFragmentFragment["id"];
  closeMenu: () => void;
  isApi?: boolean;
}) {
  const { hasPermissions } = useCheckPermissions();
  const navigate = useNavigate();

  return (
    <>
      {hasPermissions(UserPermissions.MANAGE_NOTIFICATION_TRIGGERS) && (
        <UpdateEmailTriggerMenuItem closeMenu={closeMenu} id={id} />
      )}
      {isApi && (
        <MenuItem
          onClick={() => {
            closeMenu();
            navigate(`/email-triggers/${id}/deliveries`);
          }}
        >
          View Deliveries
        </MenuItem>
      )}
    </>
  );
}
